import React from "react";
import PropTypes from "prop-types";

const TextAreaWithCounter = ({ value, onChange, rows }) => {
  return (
    <div style={{ position: "relative", width: "100%" }}>
      <textarea
        value={value}
        onChange={onChange}
        rows={rows}
        style={{ width: "100%", padding: "10px", borderRadius: "5px" }}
      />
      <div style={{ position: "absolute", bottom: "5px", right: "10px", fontSize: "12px" }}>
        {value.length} caracteres
      </div>
    </div>
  );
};

TextAreaWithCounter.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  rows: PropTypes.number,
};

TextAreaWithCounter.defaultProps = {
  rows: 5,
};

export default TextAreaWithCounter;